import {EventBus} from "../../../../common/ts/events/EventBus";
import {ShowGoogleOneTapRequestedEvent} from "./events";
import {MitulaSerpPageData} from "../SerpPage";
import tracking from "../../../../common/ts/core/tracking";
import {Device} from "../../../../common/ts/types/Device";
import {ShowRetentionPopupMobileRequestedEvent} from "../../components/retention/email/main/events";
import {PopulateFormEvent} from "../../../../common/ts/core/dom";
import {EMAIL_RETENTION_MOBILE_BOTTOM_FORM} from "../../components/retention/email/main/constants";

let eventBus: EventBus;
let pageData: MitulaSerpPageData;

function loadJS(FILE_URL: string, async = true, defer = true, pageData: MitulaSerpPageData) {
    const scriptEle = document.createElement("script");
    scriptEle.setAttribute("src", FILE_URL);
    scriptEle.setAttribute("type", "text/javascript");
    scriptEle.addEventListener("load", () => {
        //@ts-ignore
        window.google.accounts.id.initialize({
            client_id: "252924090129-dpceen6430rvpfjbks68uckhva7nf0m7.apps.googleusercontent.com",
            callback: function (googleUser: any) {
                onGoogleTapSignIn(googleUser, pageData)
            },
        });

        const hasGoogleOneTapCookie = document.cookie.indexOf('_showGoogleOneTap') !== -1
        if (!hasGoogleOneTapCookie) {
            //@ts-ignore
            window.google.accounts.id.prompt((notification) => {
                if (notification.isDisplayed()) {
                    eventBus.emit(new tracking.TrackAnalyticsEvent({
                        name: 'serp-GOT-impression'
                    }));
                }

                if (notification.isSkippedMoment()) {
                    if (pageData.device === Device.MOBILE) {
                        showEmailRetentionPopupMobile();
                    }
                }
            });
        }
    });
    document.body.appendChild(scriptEle);
}

function onGoogleTapSignIn(googleUser: any, pageData: MitulaSerpPageData) {
    const user = parseJwt(googleUser.credential);
    if (user.name && !localStorage.getItem('name')) {
        localStorage.setItem('name', user.name);
    }

    if (user.email && !localStorage.getItem('email')) {
        localStorage.setItem('email', user.email);

        eventBus.emit(new PopulateFormEvent({
            selector: EMAIL_RETENTION_MOBILE_BOTTOM_FORM,
            data: [["email", localStorage.getItem("email")]],
        }));
    }

    setCookie('_showGoogleOneTap', 'true', 365 * 24 * 60 * 60 * 1000);
    eventBus.emit(new tracking.TrackAnalyticsEvent({
        name: 'serp-GOT-signin'
    }))

    if (pageData.device === Device.MOBILE) {
        showEmailRetentionPopupMobile();
    }
}

function parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

function setCookie(name: string, value: string, expirationTimeInMs: number) {
    let date = new Date();
    date.setTime(date.getTime() + expirationTimeInMs);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; Path=/";
}

function showEmailRetentionPopupMobile() {
    eventBus.emit(new ShowRetentionPopupMobileRequestedEvent());
}

export function showGoogleOneTapRequestedHandler() {
    loadJS("https://accounts.google.com/gsi/client", true, true, pageData);
}

function init(ev: EventBus = EventBus.getInstance(), serpPageData: MitulaSerpPageData) {
    pageData = serpPageData;
    eventBus = ev;
    eventBus.subscribe(ShowGoogleOneTapRequestedEvent.TYPE, showGoogleOneTapRequestedHandler);
}

export default {
    init,
};
